import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
} from '../actions/main-actions'
import { currencyDirective, collectionDescriptionMargin } from '../directives'

// import * as fx from '../libs/money'
import HeaderTypeahead from '../components/header/HeaderTypeahead'
import HeaderSearchSection from '../components/header/HeaderSearchSection'
import VoteForTopic from '../components/collections/VoteForTopic'
import { getLanguage, getTranslations } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'

import HeroLightbox from '../components/liveaboard/HeroLightbox'
import ReactPlayer from 'react-player'
import CollectionItems from '../components/collections/CollectionItems'
import OtherCollections from '../components/collections/OtherCollections'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'
import ErrorHandler from '../components/ErrorHandler'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    numberOfTrips,
    selectedCurrency,
    itineraryPopupOpen,
    itineraryPopupData,
  }),
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('typeahead-react', HeaderTypeahead)
  renderElement('react-header-search', HeaderSearchSection)
  renderElement('video-player', ReactPlayer, {
    url: window.video && window.video.url,
    key: '1',
    volume: 1,
    loop: true,
    playing: true,
    controls: false,
    muted: true,
    width: '100%',
    height: '100%',
    className: 'player',
    config: {
      vimeo: {
        playerOptions: { background: true },
      },
    },
  })
  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.video ? [window.video] : undefined,
  })
  renderElement('operators-list', CollectionItems, {
    slug: window.collectionSlug,
    countriesFilter: window.availableCountries,
    bulletPoints: window.bulletPoints,
    bulletPointsTitle: window.bulletPointsTitle,
    collectionTitle: window.collectionTitle,
    searchPages: window.searchPages,
    countryCode: window.countryCode,
  })
  renderElement('other-collections', OtherCollections, {
    collections: window.otherCollections,
  })
  renderElement('vote-for-topic', VoteForTopic, { topics: window.topics })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  collectionDescriptionMargin()
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
